import { LABELS } from "~/resources/Labels";
import { useTranslation } from "react-i18next";
import { SIMPLButtonCustomized } from "../../../components/commons/button/SIMPLButtonCustumized";
import { LoadingWrapper } from "../../../components/commons/spiner/SimpleLoaderWrapper";
import { SIMPLInput } from "../../../components/commons/input/SIMPLInput";
import { SIMPLDialog } from "../../../components/commons/dialog/SimplDialog";
import { useFormScriptType } from "./UseFormScriptType";
import { FormScriptTypes } from "~/models/Commons ";
 interface PropScriptType {
  onCloseModal: () => void;
  editedItem: FormScriptTypes | null;
  setConfig: Function;
  title?: string;
  refetch: () => void;
  onSuccess?: (title: string, message: string, response: any) => void;
  onError?: (title: string, message: string) => void;
}
const AddScriptType = ({
  onCloseModal,
  editedItem,
  setConfig,
  refetch,
  title,
  onSuccess,
  onError,
}:  PropScriptType) => {
  const {
    handleSubmit,
    control,
    errors,
    submitForm,
    isValid,
    isSubmitting,
    isLoading,
    isError,
  } = useFormScriptType(editedItem!, onCloseModal, refetch, onSuccess, onError);

  const { t } = useTranslation();

  const handleSubmitForm = (event: React.FormEvent<HTMLFormElement>) => {
    handleSubmit(submitForm)(event);
    setConfig({
      key: "",
      direction: LABELS.ASC,
    });
  };

  const renderActions = () => (
    <>
      {!isLoading && (
        <div className="grow-0 basis-32 mr-5">
          <SIMPLButtonCustomized
            label={t("Cancel")}
            secondary
            buttonHandlerAction={onCloseModal}
            testId="script-button-cancel"
          />
        </div>
      )}

      {!isLoading && (
        <div className="grow-0 basis-32">
          <SIMPLButtonCustomized
            label={t(editedItem ? "Update" : "Submit")}
            primary
            disabled={!isValid || isSubmitting}
            testId="script-button-submit"
          />
        </div>
      )}
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={t(title as any)}
      actions={renderActions()}
      onSubmit={handleSubmitForm}
      showLine
    >
      <LoadingWrapper
        loadingTitle={t("LoadingScripts")}
        isLoading={isLoading}
        isError={isError}
        testId="loading-script"
      >
        <div className="flex justify-center">
          <div className="w-[500px]">
            <div className="flex flex-col w-full space-y-4">
              <SIMPLInput
                name="name"
                control={control}
                rules={{ required: { value: true } }}
                messageRequired={t('NameRequired')}
                label={t("Name")}
                placeholder={t("Name")}
                required
                id="name"
                testId="script-name"
                fontWeight="bold"
                errorLabel={errors.name?.message}
              />

              <SIMPLInput
                name="description"
                control={control}
                label={t("Description")}
                placeholder={t("Description")}
                id="description"
                testId="script-description"
                fontWeight="bold"
                errorLabel={errors.description?.message}
              />
            </div>
          </div>
        </div>
      </LoadingWrapper>
    </SIMPLDialog>
  );
};

export default AddScriptType;